<template>
    <q-card class="q-dialog-plugin">
        <q-card-section v-if="!props?.mode" class="row items-center q-pb-none"
            style="padding: 2vmin 2vmin;height: 7.17vmin;">
            <q-space />
            <!-- <q-icon name="close" style="font-size: 2vmin;" v-close-popup></q-icon> -->
            <q-btn style="font-size: 2vmin;" icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-separator v-if="!props?.mode" />
        <div style="padding: 2.5vmin">
            <div class="row">
                <div class="col passage" style="height: calc( 100vh - 12.27vmin )"
                    :style="!props?.mode ? '' : 'height: calc( 100vh - 5vmin )'">
                    <!-- <div v-if="reviewData.reviewContents !== null" v-html="reviewData.reviewContents" />
                    <qbankHeaderVue v-if="reviewData.reviewContents === null && questionHeader"
                        :questionHeader="questionHeader" :bookNm="bookNm" :tooltipMsg="false" /> -->
                    <qbankHeaderVue
                        :questionHeader="reviewData.reviewContents === null ? questionHeader : reviewData.reviewContents"
                        :bookNm="bookNm" :tooltipMsg="false" />
                </div>
                <div class="col answer" style="height: calc( 100vh - 14.27vmin )"
                    :style="!props?.mode ? '' : 'height: calc( 100vh - 5vmin )'">
                    <q-scroll-area ref="scrollAreaRef" visible class="answer__scroll" style="height:100%;">
                        <div>
                            <qbankProblem :p-content="problem" v-if="problem" @onChangeProblems="onChangeProblems"
                                @setInputAnswer="setInputAnswer" :answer="answer" />
                        </div>
                        <div>
                            <QbankAnswer :p-content="problem" v-if="problem" @onIntersection="onIntersection"
                                :isCore="true" />
                        </div>
                    </q-scroll-area>
                    <!-- <q-inner-loading :showing="isLoading" label="" label-class="text-teal"
                        label-style="font-size: 1.1em" /> -->
                </div>
            </div>
            <q-inner-loading :showing="isLoading" label="" label-class="text-teal" label-style="font-size: 1.1em" />
        </div>
    </q-card>
</template>

<script setup>
import { getKrtProblem } from '@/api/modules/qbank';
import { getReportReview } from '@/api/modules/study';
import qbankHeaderVue from "@/components/qbank/header.vue";
import qbankProblem from "@/components/qbank/problem.vue";
import QbankAnswer from '@/components/qbank/qbankAnswer.vue';
import { getEtcInfo, getHeader } from '@/helpers/qbankParser/qbankDataParse';
import { analysis } from '@/helpers/qbankParser/qbankMeta';
import { onMounted, watch, ref } from 'vue';

const props = defineProps({
    'answerHistorySeq': { default: '0' },
    'mode': { default: null },
});

const studyTree = ref('5083');
const questionHeader = ref(null);
const bookNm = ref(null);
const isLoading = ref(true);
const qBankData = ref(null);
const reviewData = ref({
    reviewContents: null,
    problemId: '',
    correct: '',
    answer: '',
    reAnswer: '',
    correctYn: '',
    reCorrectYn: '',
    problemClassCode: '',
    exprSyncVersion: '',
});
const problem = ref(null)


const onIntersection = () => {

};
const setAnswer = () => {

};
const getData = (seq) => {
    getReportReview({ answerHistorySeq: seq }, (r) => {
        reviewData.value = r;
        getKrtProblem({ version: r.exprSyncVersion, problemId: r.problemId }, (rs) => {
            let isMarkingNone = rs.content.property.analysis.elementId === 5091;
            qBankData.value = rs;
            const tmpStudyTree = rs.content.property.analysis.studyTreeId
            const tmpEtcInfo = getEtcInfo(rs);
            bookNm.value = tmpEtcInfo.bookNm;
            studyTree.value = tmpStudyTree;
            questionHeader.value = getHeader(rs);
            // console.log(questionHeader.value);
            problem.value = {
                // problemNo: analysis[rs.content.property.analysis.analysisId]['ord'],
                problemId: r.problemId,
                // analysisOrd: analysis[rs.content.property.analysis.analysisId]['ord'],
                etcInfo: tmpEtcInfo,
                data: rs,
                type: null,
                elapsedTime: 0,
                answer: JSON.parse(r.answer),
                reAnswer: JSON.parse(r.reAnswer),
                markingType: isMarkingNone ? '' : r.correctYn ? 'right' : (r.reCorrectYn ? 'halfRight' : 'wrong'), //'right': 정답, 'halfWrong':1차오답 , 'halfRight':2차정답 , 'wrong':2차오답
                videoTime: 0,
                relationResult: true,
                // 하단 네비 조정을 위한 변수
                result: {
                    marking: isMarkingNone ? '' : r.correctYn ? 'right' : (r.reCorrectYn ? 'halfRight' : 'wrong'),
                    answer: r.correctYn ? JSON.parse(r.answer) : JSON.parse(r.reAnswer)
                },              // 채점 여부및 1,2차 정오답 
                done: true,               // 채점및 풀이 확인 완료여부
                scrollCheck: true,             // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
                relationId: rs.content.property.problem?.relations?.length > 0 ? rs.content.property.problem?.relations[0].relationId : null,           // 확인 문제 있는지 여부
                completeVideo: true,         // 영상 시청 여부
                // TODO: 큐뱅크 해설영상 파싱필요 
                videoUrl: null,              // 해설 영상 여부
                problemClassCode: r.problemClassCode,
            }
            isLoading.value = false;
        })

    });
}
onMounted(() => {
    // console.log('onMounted');
    // console.log(props.answerHistorySeq);
    if (props.answerHistorySeq) {
        getData(props.answerHistorySeq);
    }
})

watch(() => props.answerHistorySeq, (newValue) => {
    // console.log('onMounted');
    // console.log(props.answerHistorySeq);
    if (newValue) {
        getData(newValue);
    }
});

</script>

<style scoped lang="scss">
.passage {
    +.answer {
      &::before {
        content: '';
        position: absolute;
        top: 46%;
        left: 0;
        width: 1px;
        height: 91%;
        max-height: 974px;
        background: $color_gray_500;
        @include transform(translateY(-50%));
      }
    }
  }
  
  .answer {
    position: relative;
    // padding: 0 4.17vmin;
  
    &__scroll {
        padding: 0 5.17vmin 3.33vmin 4.08vmin;
      // padding-right: 5.17vmin;
      // padding-bottom: 3.33vmin;
    }
  }
  
  ::v-deep {
    .q-scrollarea__content {
      padding-bottom: 3.33vmin;
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
  }
</style>
